module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av154-9a12e5042f32cd1a330517991031ed99.jpg";